<template>
  <div class="container">
    <competition-year-header :year="2021"/>
    <competition-rules2021 class="mb-3"/>
    <div class="table-responsive">
      <table class="table table-bordered w-auto">
        <thead>
          <tr>
            <th colspan="4"></th>
            <th :colspan="competitors.length">Účastníci tipovací soutěže ({{ competitors.length }})</th>
          </tr>
          <tr>
            <th>Závodníci</th>
            <th>Umístění</th>
            <th>Průměrný tip</th>
            <th>Medián</th>
            <th v-for="({name, date}, index) in competitors" :key="index">
              <link-person :person="name"/>
              <br/>
              <span class="date">{{date}}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(racer, racerIndex) in racers" :key="racerIndex">
            <td><link-person :person="racer"/></td>
              <td title="Reálné umístění 2021">
                  <base-medal v-if="results && results[racerIndex]" :order="results[racerIndex]"/>
              </td>
              <td title="Zprůměrovaný tip (zaokrouhleno)">
                  <base-medal v-if="averages[racerIndex]" :order="averages[racerIndex]"/>
              </td>
              <td title="Medián (zaokrouhleno)">
                  <base-medal v-if="medians[racerIndex]" :order="medians[racerIndex]"/>
              </td>
            <td v-for="(competitor, competitorIndex) in competitors" :key="competitorIndex" :title="`Tipuje: ${competitor.name}`" class="text-right">
              {{competitor.tips[racerIndex]}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
    import TimeComparisonCell from "@/components/TimeComparisonCell";
    import BaseMedal from "@/components/BaseMedal";
    import HeaderCell from "@/components/HeaderCell";
    import TableHeader from "@/components/TableHeader";
    import Registration from "@/components/Registration";
    import LinkPerson from "@/components/LinkPerson";
    import CompetitionRules2021 from "@/components/CompetitionRules2021";
    import CompetitionYearHeader from "@/components/CompetitionYearHeader";

    export default {
      components: {
          CompetitionYearHeader,
          CompetitionRules2021, LinkPerson, Registration, TableHeader, HeaderCell, BaseMedal, TimeComparisonCell},
      computed: {
        competition() {
          //return this.$store.state.data[this.year].competition;
          return {
            racers: ["Adamec Miroslav","Balický Břetislav","Balický Jiří","Bendl Lukáš","Bendl Michal","Beránek Tomáš","Bláha Jiří","Dvořáková Iva","Fedrová Šárka","Frýda Lukáš","Hanuš Tomáš","Hladík Pavel","Hojgr Jiří","Holman Ladislav","Chmel Václav","Chýlek Petr","Chýlek Richard","Chýlková Martina","Jánský Libor","Jedlička Petr","Kazda Pavel","Kazdová Dagmar","Kollátor Aleš","Korbel Michal","Kričfaluši Jan","Kutnar Jiří","Kutnar Patryk","Ludvík Pavel","Michal Martin","Maštalíř Martin","Mužík Jan","Nečas Jiří","Němec Pavel","Nová Jana","Pavlík Jiří","Pošík Vladimír","Rybanská Dagmar","Rybanský Jakub","Sejkora Martin","Sejkorová Kristýna","Sigler Jaroslav","Suchý Jaromír","Šerák Martin","Šrámek Richard","Veselka Šimon","Veselka Zdeněk","Zeman Martin"],
            competitors: [
              {name: "Kutnar Jiří", date: "9.8.2021 15:18", tips: [17,39,8,38,37,18,13,46,45,36,19,44,6,40,7,26,25,27,12,28,14,43,15,24,35,16,34,23,4,29,10,33,32,31,30,20,42,41,11,47,3,2,22,21,5,1,9]},
              {name: "Kollátor Aleš", date: "9.8.2021 16:34", tips: [15,30,12,10,22,27,14,21,28,46,29,18,9,32,11,38,20,43,33,41,8,42,5,19,31,16,40,35,7,36,2,37,39,47,44,26,34,24,13,45,4,3,23,25,6,1,17]},
              {name: "Kutnar Patryk", date: "10.8.2021 15:31", tips: [25,24,6,23,13,42,14,39,40,38,43,44,45,47,22,12,26,27,41,37,8,21,35,36,28,16,30,15,2,31,9,17,29,33,32,20,34,18,7,46,4,3,5,19,10,1,11]},
              {name: "Balický Jiří", date: "12.8.2021 7:51", tips: [11,22,14,23,24,43,15,21,45,29,46,19,7,28,8,44,16,47,30,42,12,41,6,17,32,13,31,33,5,40,2,25,38,39,34,26,37,35,10,36,3,4,27,20,9,1,18]},
              {name: "Kazda Pavel", date: "13.8.2021 6:24", tips: [12,24,13,23,19,36,17,18,42,33,34,16,9,32,8,35,15,39,31,25,47,41,6,28,20,11,22,37,2,38,3,43,27,46,44,26,40,29,10,45,5,4,30,21,7,1,14]},
              {name: "Bláha Jiří", date: "16.8.2021 10:56", tips: [12,35,11,9,30,41,15,20,40,31,39,14,6,22,8,47,17,45,21,29,3,44,7,16,28,18,33,38,4,37,34,23,24,46,27,32,43,26,10,36,5,2,25,13,19,1,42]},
              {name: "Frýda Lukáš", date: "16.8.2021 13:02", tips: [30,22,20,3,9,31,21,29,33,47,34,23,5,35,19,28,36,41,37,18,4,38,8,24,16,7,17,39,2,40,6,27,26,43,32,25,45,44,13,42,10,14,46,12,11,1,15]},
              {name: "Hladík Pavel", date: "16.8.2021 13:47", tips: [13,32,15,10,25,36,17,24,37,31,38,19,6,27,11,39,22,40,28,29,7,41,5,14,23,18,30,42,8,43,2,20,44,35,34,26,45,46,12,33,4,3,47,21,9,1,16]},
              {name: "Mužík Jan", date: "17.8.2021 10:05", tips: [14,42,11,26,22,27,17,20,36,43,35,18,9,23,10,34,19,33,32,31,7,24,5,25,21,16,39,38,8,15,2,41,40,47,44,29,46,37,13,45,4,3,28,30,6,1,12]},
              {name: "Nečas Jiří", date: "17.8.2021 15:30", tips: [10,31,12,20,19,28,11,17,42,32,29,16,7,21,9,41,13,46,23,25,18,26,6,43,22,15,27,40,44,45,2,30,39,38,35,24,36,37,8,33,4,3,34,47,5,1,14]},
              {name: "Rybanská Dagmar", date: "17.8.2021 15:31", tips: [13,31,12,46,24,45,11,19,44,35,43,17,8,25,9,42,15,47,29,30,18,23,5,22,20,16,39,40,33,41,1,32,21,36,37,28,26,3,10,34,4,2,27,38,6,7,14]},
              {name: "Chýlková Martina", date: "17.8.2021 17:16", tips: [11,33,12,39,23,46,13,20,43,38,42,15,6,22,9,36,14,47,25,34,19,44,7,45,17,16,27,28,37,26,3,29,21,40,41,24,35,30,10,32,5,2,31,18,4,1,8]}
            ]
          };
        },
        competitors() {
          return this.competition.competitors;
        },
        racers() {
          return this.competition.racers;
        },
        averages() {
          return this.racers
              .map((racer, racerIndex) =>
                      Math.round(this.competitors.reduce( (sum, competitor) => sum + competitor.tips[racerIndex], 0) / this.competitors.length)
              );
        },
        medians() {
          const asc = arr => arr.sort((a, b) => a - b);
          const quantile = (arr, q) => {
            const sorted = asc(arr);
            const pos = (sorted.length - 1) * q;
            const base = Math.floor(pos);
            const rest = pos - base;
            if (sorted[base + 1] !== undefined) {
              return sorted[base] + rest * (sorted[base + 1] - sorted[base]);
            } else {
              return sorted[base];
            }
          };
          const q50 = arr => quantile(arr, .50);
          return this.racers
                  .map((racer, racerIndex) => q50(this.competitors.map(competitor => competitor.tips[racerIndex])))
                  .map(median => Math.round(median));
        },
        resultsByYear2021() {
          return this.$store.getters.resultsByYear(2021);
        },
        results() {
          return this.racers
            .map(racer => this.resultsByYear2021.find(result => result.person === racer))
            .map(racerResult => racerResult ? racerResult.order : null);
        }
      }
    };
</script>

<style scoped lang="scss">
  @import "~@/assets/scss/variables";

  tr {
    td, th {
      &:nth-child(4), &:last-child, &:first-child {
        border-right-color: #333;
      }
      &:first-child {
        border-left-color: #333;
      }
    }

    &:first-child {
      th {
        border-top-color: #333;
      }
    }

    &:last-child {
      th, td {
        border-bottom-color: #333;
      }
    }
  }

  thead {
    tr:nth-child(2) th:nth-child(n+2) {
      writing-mode: vertical-rl;
      transform: rotate(180deg);
      padding: 0.75rem 0.25rem ;
    }

    .date {
      font-weight: normal;
      font-size: 0.9em;
    }
  }
  tbody {
    tr {
      &:hover {
        background-color: #e3d4ff;
      }
      td:nth-child(n+2) {
        cursor: help;
      }
    }
  }
  .table td {
    cursor: inherit;
  }
</style>